export const jobs = [
  {
    "id": 1,
    "company": "Ford Motor Company",
    "role": "Associate Product Manager",
    "type": "Full-time",
    "period": "Jun 2026 – Present",
    "location": "Dearborn, Michigan",
    "current": true,
    "tech": [
      "Product requirements",
      "Customer interviews",
      "Jira",
      "Confluence"
    ],
    "bullets": [
      "Driving the launch of a new scheduling feature with mobile engineering and design to surface the next 24 hours of departures, software updates, and charging; targeting monthly active usage of 30% on the home screen and 10% on the full schedule page.",
      "Cut intake and planning time by 50% by centralizing platform requests in Jira, replacing messages, emails, and Confluence tracking while enabling leadership to stack-rank work.",
      "Used customer interviews to shape a Lincoln Navigator health widget prototype, retaining essential metrics and removing those customers found unnecessary or stressful; built integrations with Apple Watch, supported Android watches, and Oura Ring.",
      "Defined product requirements (PRD) for an ongoing mobile architecture redesign focused on reusable capabilities, targeting 30% shorter feature delivery cycles and a 50% reduction in screen load time."
    ]
  },
  {
    "id": 2,
    "company": "Ford Motor Company",
    "role": "Software Engineer, Digital Product Lab",
    "type": "Full-time",
    "period": "Jan 2026 – Jun 2026",
    "location": "Dearborn, Michigan",
    "current": false,
    "tech": [
      "C++",
      "Bluetooth",
      "Prototyping",
      "Network testing"
    ],
    "bullets": [
      "Enabled a product manager and development team to evaluate in-vehicle gaming under poor connectivity by building an internal network test device with bandwidth controls and packet-loss simulation.",
      "Built a C++ steering-wheel prototype for the design team to simulate steering-wheel interactions through Bluetooth keyboard inputs."
    ]
  },
  {
    "id": 5,
    "company": "Ford Motor Company",
    "role": "Software Validation Test Engineer",
    "type": "Full-time",
    "period": "Sep 2025 – Jan 2026",
    "location": "Dearborn, Michigan",
    "current": false,
    "tech": [
      "Python",
      "Test automation"
    ],
    "bullets": [
      "Reduced test time for 30 Battery Energy Control Module requirements from 90 minutes to 5 minutes through Python automation; developed 2 scripts from concept through production integration."
    ]
  },
  {
    id: 3,
    company: "Ford Motor Company",
    role: "Software Engineer Intern",
    type: "Internship",
    period: "Jun 2024 – Aug 2024",
    location: "Dearborn, Michigan",
    current: false,
    tech: ["Java", "Groovy", "C", "AUTOSAR", "CI/CD", "Agile", "JIRA"],
    bullets: [
      "Developed a full-stack internal tool within an Agile framework to automate ECU run-time environment generation, saving over 70% of manual processes.",
      "Implemented 2 production-ready Battery Electric Control Module communication features using C and AUTOSAR architecture, integrated within a CI/CD pipeline managed through JIRA.",
      "Spearheaded migration from BTC to Simulink Test, implementing over 100 end-to-end test cases to ensure high code quality and reliability.",
    ],
  },
  {
    id: 4,
    company: "Acsia",
    role: "Software Engineering / Project Management Intern",
    type: "Internship",
    period: "May 2023 – Aug 2023",
    location: "Bangalore, India",
    current: false,
    tech: ["C", "AUTOSAR", "Polarion", "APIs", "ISO 26262"],
    bullets: [
      "Developed over 400 system, software and electrical requirements for a multi-million dollar automotive project.",
      "Collaborated with the Functional Safety team to analyze diagnostic trouble codes distributed by the ECU via CAN.",
      "Streamlined work protocols by managing meeting minutes and bug trackers under Agile and ASPICE/ISO 26262, achieving deadlines 50% faster.",
    ],
  },
];
